import React from "react";
import { Modal, Row, Col, Form, Button } from "react-bootstrap";
import { Controller } from "react-hook-form";
import MultiSelect from "components/common/MultiSelect";

const DoctorEditModal = ({
    showModal,
    handleCancel,
    handleSave,
    control,
    errors,
    practitionerList,
    handleInputChange,
    specialties,
    practitionerRoleList,
}) => {
    const getPractitionerLabel = (p) =>
        `(${p.practitioner_license || ""}) - ${p.practitioner_title || "Dr"} ${p.practitioner_firstname || ""
        } ${p.practitioner_fathername || ""} ${p.practitioner_familyname || ""}`;

    return (
        <Modal centered show={showModal} onHide={handleCancel}>
            <Modal.Header closeButton>
                <Modal.Title className="fs-10">Edit Doctor Information</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col xs={12}>
                        <Form.Group className="mb-3">
                            <Form.Label className="d-flex align-items-center fs-12">
                                Doctor Name
                                {errors.practitioner && (
                                    <span className="text-danger ms-2 fs-12">
                                        Doctor is Required
                                    </span>
                                )}
                            </Form.Label>
                            <Controller
                                name="practitioner"
                                control={control}
                                rules={{ required: true }}
                                render={({ field }) => (
                                    <MultiSelect
                                        {...field}
                                        isMulti={false}
                                        menuPlacement="auto"
                                        size="sm"
                                        options={practitionerList?.map((p) => ({
                                            value: p,
                                            label: getPractitionerLabel(p),
                                        }))}
                                        placeholder="Select Practitioner"
                                        isClearable={true}
                                        value={field.value || null}
                                        onChange={(selected) =>
                                            handleInputChange("practitioner", selected)
                                        }
                                    />
                                )}
                            />
                        </Form.Group>
                    </Col>
                    <Col xs={12}>
                        <Form.Group className="mb-3">
                            <Form.Label className="d-flex align-items-center fs-12">
                                Speciality
                                {errors.specialty && (
                                    <span className="text-danger ms-2 fs-12">
                                        Speciality is Required
                                    </span>
                                )}
                            </Form.Label>
                            <Controller
                                name="specialty"
                                control={control}
                                rules={{ required: true }}
                                render={({ field }) => (
                                    <MultiSelect
                                        {...field}
                                        isMulti={false}
                                        menuPlacement="auto"
                                        options={specialties?.map((s) => ({
                                            value: s.specialities_code,
                                            label: s.specialities_name,
                                        }))}
                                        placeholder="Select Speciality"
                                        isClearable={true}
                                        value={field.value || null}
                                        onChange={(selected) =>
                                            handleInputChange("specialty", selected)
                                        }
                                    />
                                )}
                            />
                        </Form.Group>
                    </Col>
                    <Col xs={12}>
                        <Form.Group className="mb-3">
                            <Form.Label className="d-flex align-items-center fs-12">
                                Role
                                {errors.role && (
                                    <span className="text-danger ms-2 fs-12">
                                        Role is Required
                                    </span>
                                )}
                            </Form.Label>
                            <Controller
                                name="role"
                                control={control}
                                rules={{ required: true }}
                                render={({ field }) => (
                                    <MultiSelect
                                        {...field}
                                        isMulti={false}
                                        menuPlacement="auto"
                                        options={practitionerRoleList?.map((r) => ({
                                            value: r.careroles_code,
                                            label: r.careroles_name,
                                        }))}
                                        placeholder="Select Role"
                                        isClearable={true}
                                        value={field.value || null}
                                        onChange={(selected) => handleInputChange("role", selected)}
                                    />
                                )}
                            />
                        </Form.Group>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCancel}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleSave}>
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default React.memo(DoctorEditModal);
